let counter = 0;

function disableDocumentScroll() {
    counter++;
    document.body.classList.add('modal-opened');
}
function enableDocumentScroll() {
    counter--;
    if(counter < 0) counter = 0;
    if(counter === 0) document.body.classList.remove('modal-opened');
}


export  {
    disableDocumentScroll,
    enableDocumentScroll,
}